import { faFaceViewfinder } from "@fortawesome/pro-regular-svg-icons/faFaceViewfinder";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { FC } from "react";

export const FaceViewfinderIcon: FC<JSX.IntrinsicAttributes> = (props) => {
  return <FontAwesomeIcon icon={faFaceViewfinder} {...props} />;
};
